var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperlikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1537 12.4347C16.2365 12.2773 16.231 12.0182 16.1391 11.8658C16.0471 11.7129 15.8814 11.5504 15.7038 11.5504H13.1491L14.5475 6.30761C14.5873 6.15515 14.5548 5.95746 14.4583 5.83296C14.3621 5.70847 14.2134 5.60001 14.0559 5.60001H10.5294C10.2982 5.60001 10.0964 5.82519 10.0378 6.04856L8.01691 13.7633C7.97662 13.9161 8.00914 14.026 8.10576 14.1514C8.2019 14.2754 8.35066 14.297 8.50853 14.297H12.1195V18.9859C12.1195 19.1452 12.1525 19.2839 12.3072 19.3219C12.4619 19.3599 12.5846 19.2881 12.6587 19.1471L16.1537 12.4347Z",
    fill: "#FFC700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperlikeIcon);
export default __webpack_public_path__ + "static/media/superlike_icon.078ff8afb60be9100cdd4f2f939ff2e1.svg";
export { ForwardRef as ReactComponent };